
<div class="days-container">
    <button mat-stroked-button *ngFor="let button of buttonsMap; let i = index" [ngClass]="itemClasses(i)" (click)="toggleValue(i)">
        {{ button.name }}
    </button>
</div>